import {
  Autocomplete,
  FormControl,
  FormLabel,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import React, { useEffect } from "react";
import {
  MAXIMUM_VEHICLE_HEIGHT,
  WIDTH_100,
} from "../../../utils/GlobalConstants";
import TextInput from "../textInput/TextInput";

export function SelectView(props) {
  const [item, setItem] = React.useState(props.value ? props.value : "");
  const [data, setData] = React.useState(props.data);
const [dropDownItem, setDropDownItem]= React.useState(props.value);

useEffect(()=>{
  setDropDownItem(props?.value)
},[props?.value])
  const handleChange = (event, item) => {
    setItem(event.target.value);
    props.onHandleChange(event.target.value);
  };
 const handleDropDownChange = (item) => {
    
    setDropDownItem(item);
    props.onHandleChange(item);
  };
  useEffect(() => {
    setData(props.data);
  }, [props.data]);

  useEffect(() => {
    setItem(props.value);
  }, [props.value]);

  const handleOnKeyDown = (e) => {
    props.onKeyDown(e);
  };
  const handleOnBlur = (e) => {
    if (props.onBlur) {
      props.onBlur(e);
    }
  };
  return (
    <FormControl fullWidth sx={WIDTH_100} size="small" className="input-select">
      <FormLabel
                htmlFor={props.label}
               sx={{
                color: props.error ? "error.main" : "text.primary",
                "& .required-asterisk": {
                  color: props.error ? "error.main" : "inherit",
                },
              }} 
              >
                 {props.label}

               {props.required &&<span className={"required-asterisk"}> <i>(Required *)</i></span>}
              </FormLabel>
      {props.search ? (
        <Autocomplete
    data-testid={props.testId ? props.testId : "surveyselec"}
          disablePortal
          options={props.data}
          disabled={props.disabled ? props.disabled : false}
          fullWidth
          value={dropDownItem}
          getOptionLabel={(option)=>option?.label||""}
         onChange={(e,val) => {handleDropDownChange(val)}}
          renderInput={(params) => (
            <TextInput
              {...params}
              label={props.label}
              required={props.required}
              size="small"
              inputProps={{
                ...params.inputProps,
                ...props.inputProps,
              }}
              error={props.error}
              helperText={props.error ? props.textError : ""}
              onKeyDown={(e) => {
                handleOnKeyDown(e);
              }}
              onBlur={(e) => {
                handleOnBlur(e);
              }}
              PopperProps={{
                placement: "bottom-start",
                modifiers: [
                  {
                    name: "flip",
                    enabled: false,
                  },
                  {
                    name: "preventOverflow",
                    enabled: true,
                    options: {
                      altAxis: true,
                      tether: false,
                      boundary: "veiwport",
                    },
                  },
                ],
              }}
            />
          )}
        />
      ) : (
        <>
           <InputLabel id="demo-select-big-label" className="visually-hidden" shrink>{props.label}</InputLabel> 
          <Select
            disabled={props.disabled ? props.disabled : false}
            size="small"
            labelId="demo-select-big-label"
            id="demo-select-big"
            data-testid={props.testId ? props.testId : "select-survey-id"}
            testid="select-survey-from-survey-page"
            value={item !== undefined ? item : ""}
             label={props.label}
            onChange={(e) => handleChange(e)}
            MenuProps={{
              style: MAXIMUM_VEHICLE_HEIGHT,
            }}
          >
            {data &&
              data.map((item, key) => {
                return (
                  <MenuItem key={key} value={item?.id}>
                    {item?.surveyName && item?.surveyName}
                    {item?.fleetName && item?.fleetName}{" "}
                    {item?.storeName && item?.storeName}
                    {item?.name && item?.name}
                    {item?.partType && item?.partType}
                    {item?.position && item?.position}
                  </MenuItem>
                );
              })}
          </Select>
        </>
      )}
    </FormControl>
  );
}
